import { ContentSpacing } from 'elc-base-theme';
import { observer } from 'mobx-react';
import * as React from 'react';
import styled from 'styled-components';
import { ScrollSliderDotTheme } from '../../theme/default-theme';
import { classes } from '../../internal/utils/Classes';

export interface IProductImageNavMenu {
    key?: string;
    className?: string;
    onClick?(): void;
}

export const NavItem = styled.button`
    &::before {
        display: block;
        width: 8px;
        height: 8px;
    }

    cursor: pointer;
    padding: ${ContentSpacing.space8};
    margin-right: ${ContentSpacing.space16};

    [dir='rtl'] & {
        margin-right: 0;
        margin-left: ${ContentSpacing.space16};
    }

    ${ScrollSliderDotTheme};
`;

@observer
class ProductImageNavMenu extends React.Component<IProductImageNavMenu> {
    public static displayName: string;
    private imageNavMenuItemClassNames = classes('image-nav-menu-item', this.props.className);

    render() {
        return (
            <NavItem
                className={this.imageNavMenuItemClassNames}
                title={this.props.key}
                {...this.props}
            />
        );
    }
}

ProductImageNavMenu.displayName = 'ProductImageNavMenu';

export default ProductImageNavMenu;
